'use es6';

export var ALIGNMENT_CLASSES = {
  start: '',
  baseline: 'private-checkbox--align-baseline',
  center: 'private-checkbox--align-center',
  end: 'private-checkbox--align-end'
};
export var PADDING_OPTIONS = {
  default: '',
  none: 'private-checkbox--flush'
};
export var SIZE_OPTIONS = {
  default: '',
  sm: 'private-checkbox--small'
};